/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { createAgent } from "@vlinder-web/plugin-agent-service-react";
import {
  HeaderService,
  IHeaderMethods,
  SettingsService,
  ISettingsMethods,
  IStaticPageContentMethods,
  StaticPageContentService,
  IDeleteUserMethods,
  DeleteUserService,
  IReInviteUserMethods,
  ReInviteUserService,
  ISuspendUserMethods,
  SuspendUserService,
  ActivateUserService,
  IActivateUserMethods,
  IInviteUserMethods,
  InviteUserService,
  IDistributorListMethods,
  DistributorListService,
} from "./components";

export type DistributorPageAgent = IHeaderMethods &
  ISettingsMethods &
  IStaticPageContentMethods &
  IReInviteUserMethods &
  ISuspendUserMethods &
  IActivateUserMethods &
  IDeleteUserMethods &
  IInviteUserMethods &
  IDistributorListMethods;

const getPlugins = () => {
  return [
    new StaticPageContentService(),
    new HeaderService(),
    new SettingsService(),
    new DeleteUserService(),
    new ReInviteUserService(),
    new SuspendUserService(),
    new ActivateUserService(),
    new InviteUserService(),
    new DistributorListService(),
  ];
};

export const getAgent = () => {
  return createAgent<DistributorPageAgent>({
    plugins: getPlugins(),
  });
};
